export class AddRetentionSchedule {
    constructor(retentionScheduleRepository) {
      this.retentionScheduleRepository = retentionScheduleRepository;
    }  
    async execute(RetentionScheduleRequest) {
      return await this.retentionScheduleRepository.addRetentionSchedule(RetentionScheduleRequest);
  }
}